import { PatientLastMissedCheckMetaV1 } from '../../dto/UserMetaV1';

export const QUESTIONNAIRE_LAST_MISSED_CHECK_V1 = 'QUESTIONNAIRE_LAST_MISSED_CHECK_V1';

export const createLastMissedCheckMetaV1 = (timestamp: string): PatientLastMissedCheckMetaV1 => ({
  type: QUESTIONNAIRE_LAST_MISSED_CHECK_V1,
  name: QUESTIONNAIRE_LAST_MISSED_CHECK_V1,
  data: {
    timestampIsoDateTime: timestamp,
  },
});
